import { create } from 'zustand';
import { getState, useState } from '@/framework';
import { IExportState, ILayerProps, StateType } from '@/version-types';

/** 状态 */
interface IState {
    /** 原始背景 */
    originBackground: Map<string, ILayerProps>;
}

/** 动作 */
interface IAction {
    /** 获取原始背景 */
    getOriginBackground: (id: string) => ILayerProps;
    /** 设置原始背景 */
    setOriginBackground: (originBackground: ILayerProps) => void;
    /** 销毁 */
    destroy: () => void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 初始化状态 */
function getInitialState() {
    return {
        originBackground: new Map(),
    };
}

/** 创建存储 */
const createState = (identity: string) => {
    const store = create<IStore>((set, get) => ({
        ...getInitialState(),

        getOriginBackground(id) {
            return get().originBackground.get(id) as ILayerProps;
        },
        setOriginBackground(originBackground) {
            if (!get().originBackground.has(originBackground.id)) {
                get().originBackground.set(originBackground.id, originBackground);
            }
        },
        destroy() {
            get().originBackground.clear();
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'background-layer-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useBackgroundLayerState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getBackgroundLayerState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
